// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"gRn9toV7fywWDS22xkDSv","Chart":"_3umU2haLQMkoxEreMkqz-e","Card":"_1Cl8Gk7yJzz59wfUTOx8d4","Header":"_2jKyzwwH4DN1B9qmu3ZVkO","Content":"_2TWBGB6uLpzV1aGMivfZ5k","Wrapper":"_37aC3IbM6aVTTWvbprpL6a","Table":"_2jMWX2q4HJ8r5wQ3_kgZ2H","Empty":"_1_KxPX5W4gOBZs6I_-Yh7T","EmptyRow":"_3092Ded0WzkyVj-gajWlJO"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Charts/CountryChart/styles.module.css
// module id = 195
// module chunks = 0